const modalBackups = {
  title: 'Editar Backup',
  placeholder: 'Pesquisar',
  name: 'Nome do arquivo',
  size: 'Tamanho',
  fileType: 'Tipo do arquivo',
  createdAt: 'Criado em',
  createdBy: 'Criado por',
  ingestedBy: 'Consumido por',
  ingestedAt: 'Consumido em',
  ingested: 'Consumido',
};

export default modalBackups;
